// @flow
import { GET_ALL_BLOGS } from './actionTypes'

export default ({ pagination, filterGroup }) => ({
  type: GET_ALL_BLOGS,
  payload: {
    pagination,
    filterGroup, // filters, favorites, unFiltered
  }
})